import * as FSR from "src/generated/hooks/form-service/requests";
import z from "zod";
/**
 * Type definition for the schools import schema
 * This is used by ts-json-schema-generator to generate JSON schemas
 */
export type ImportSchoolsAndGradesForEnrollmentPeriodSchema =
  FSR.ImportSchoolsAndGradesForEnrollmentPeriodData["body"]["schools"];

// used by importEPSchoolBoundaryConnections-schema
export type ImportSchoolBoundaryConnectionsDataSchema =
  FSR.ImportSchoolBoundaryConnectionsData["body"]["connections"];

export const ImportSchoolBoundaryConnectionsSchema = z.array(
  z.object({
    boundary_key: z.string().min(1, "Boundary key must not be empty"),
    school_reference_id: z
      .string()
      .min(1, "School reference id must not be empty"),
    grade_config_value_key: z.nullable(
      z
        .string()
        .min(1, "Grade config value key must not be empty or must be null")
    ),
    label: z.nullable(
      z.string().min(1, "Label must be populated or must be null")
    ),
    is_inside: z.boolean(),
  })
);

export type ImportSchoolBoundaryConnections = z.infer<
  typeof ImportSchoolBoundaryConnectionsSchema
>;
